import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { hublocationService } from '../services/hublocationService'

export const getAllHub = createAsyncThunk(
  'hublocation/getAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await hublocationService.getAll()
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const getOneHub = createAsyncThunk(
  'hublocation/getOne',
  async (data, { rejectWithValue }) => {
    try {
      const response = await hublocationService.getOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const createHub = createAsyncThunk(
  'hublocation/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await hublocationService.createHubLocation(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const editHub = createAsyncThunk(
  'hublocation/edit',
  async (data, { rejectWithValue }) => {
    try {
      const response = await hublocationService.editHubLocation(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const deleteHub = createAsyncThunk(
  'hublocation/delete',
  async (data, { rejectWithValue }) => {
    try {
      const response = await hublocationService.deleteOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

const initialState = {
  data: [],
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'hub',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllHub.pending]: (state) => {
      if (state.data.length <= 0) {
        state.loading = true
      }
    },
    [getAllHub.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllHub.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getOneHub.pending]: (state) => {
      state.loading = true
    },
    [getOneHub.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [getOneHub.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [createHub.pending]: (state) => {
      state.loading = true
    },
    [createHub.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [createHub.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [editHub.pending]: (state) => {
      state.loading = true
    },
    [editHub.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [editHub.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [deleteHub.pending]: (state) => {
      state.loading = true
    },
    [deleteHub.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [deleteHub.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
